import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Manifesto from "@/components/Manifesto";
import ModelsOverview from "@/components/ModelsOverview";
import ClosingCTA from "@/components/ClosingCTA";

export default function Home() {
  return (
    <main data-testid="home-page">
      <Hero />
      <Marquee />
      <Manifesto />
      <ModelsOverview />
      <ClosingCTA />
    </main>
  );
}
